// @flow

import * as React from 'react';
import Group from 'sail/Group';
import {Text} from 'sail/Text';
import {getRootPathForArticle} from 'docs/util';

import type {Article} from 'docs/data';

type FilenameProps = {|
  article: Article,
|};

export const Filename = ({article}: FilenameProps) => {
  if (!article.xray) {
    console.warn('Missing necessary x-ray data. Please contact #docs-product!'); // eslint-disable-line no-console
    return null;
  }

  if (!article.xray.filename) {
    return null;
  }

  const {filename} = article.xray;
  const lastIndex = filename.lastIndexOf('/');
  const pathname = filename.slice(0, lastIndex + 1);
  const basename = filename.slice(lastIndex + 1);

  return (
    <Group
      padding={{vertical: 8, horizontal: 20}}
      spacing={2}
      background="surface"
      divider={{color: 'light', width: 1, side: 'top'}}
      style={{marginLeft: -20, marginRight: -20}}
    >
      <Text size={12} weight="medium">
        {getRootPathForArticle(article)}
      </Text>
      <Text size={12} weight="medium">
        ↳ {pathname}
      </Text>
      <Text size={12} weight="medium">
        ↳ {basename}
      </Text>
    </Group>
  );
};
